__turbopack_context__.v({
  "link": "CoreArticleAuthors-module-scss-module__izu3IW__link",
  "list": "CoreArticleAuthors-module-scss-module__izu3IW__list",
  "main": "CoreArticleAuthors-module-scss-module__izu3IW__main",
});
